import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/repositories/optilink-parent/management-tool-frontend/layouts/default.vue").then(m => m.default || m)),
  private: defineAsyncComponent(() => import("C:/repositories/optilink-parent/management-tool-frontend/layouts/private.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("C:/repositories/optilink-parent/management-tool-frontend/layouts/public.vue").then(m => m.default || m))
}